import { all } from "redux-saga/effects";
import { legalGroupSaga } from "./legalGroupSaga";
import { legalDocumentSaga } from "./legalDocumentSaga";

export default function* legalSaga() {
    yield all([
        legalGroupSaga(),
        legalDocumentSaga()
    ])
}